"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[4028],{

/***/ 44028:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var _FirebaseMessaging;
const FirebaseMessagingService = (_FirebaseMessaging = class FirebaseMessaging {
    static load() {
        var _this = this;
        return _async_to_generator(function*() {
            const { initializeApp, getApps } = yield Promise.all(/* import() */[__webpack_require__.e(4086), __webpack_require__.e(9866)]).then(__webpack_require__.bind(__webpack_require__, 29866));
            const { getMessaging, isSupported } = yield Promise.all(/* import() */[__webpack_require__.e(4086), __webpack_require__.e(2266)]).then(__webpack_require__.bind(__webpack_require__, 32266));
            const supported = yield isSupported();
            const apps = getApps();
            if (!apps.length && supported) {
                const app = initializeApp(FirebaseMessagingService.config);
                FirebaseMessagingService.firebase = app;
                FirebaseMessagingService.messaging = getMessaging(app);
                if (Notification.permission !== 'granted') {
                    const permission = yield Notification.requestPermission();
                    if (permission === 'granted') {
                        _this.getBrowserToken();
                    }
                }
            }
        })();
    }
    static getBrowserToken() {
        var _this = this;
        return _async_to_generator(function*() {
            const { getToken } = yield Promise.all(/* import() */[__webpack_require__.e(4086), __webpack_require__.e(2266)]).then(__webpack_require__.bind(__webpack_require__, 32266));
            const currentUserData = {
                email: window.currentUser.email
            };
            getToken(_this.messaging, {
                vapidKey: 'BApC_wbUDWP6wYen_MCwpvMFpOfvLPNodspP10MbfMidg20fI4YnR-_6ABq9-BjQLXrAl1IMcQQ7Wm02Qo2Ntx0'
            }).then((browserToken)=>{
                if (browserToken) {
                    fetch('https://api.iterable.com/api/users/registerBrowserToken', {
                        method: 'POST',
                        headers: {
                            'Api-Key': FirebaseMessagingService.iterableKeys[RAILS_ENV],
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(_extends({
                            browserToken
                        }, currentUserData))
                    });
                }
            });
        })();
    }
}, _FirebaseMessaging.firebase = null, _FirebaseMessaging.messaging = null, _FirebaseMessaging.config = {
    apiKey: 'AIzaSyBKssxN2MqRoTZ6r9T9w-PLdOHVWv8YHac',
    authDomain: 'fbase-qconcursos.firebaseapp.com',
    projectId: 'fbase-qconcursos',
    storageBucket: 'fbase-qconcursos.appspot.com',
    messagingSenderId: '715855447853',
    appId: '1:715855447853:web:905dca4ac99203b69a35a4',
    measurementId: 'G-ZVRG84G7CP'
}, _FirebaseMessaging.iterableKeys = {
    production: '0a04113a7f134d48b60cc2250428121a',
    staging: '08466cc16b524a62a13e5a9449b05f11',
    development: '2368c59f13ad48e4be052c53b3335901'
}, _FirebaseMessaging);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FirebaseMessagingService);


/***/ })

}]);